import { DropdownMenu } from "@/common/DropdownMenu";
import { BlocksMenuIcon } from "@/shared/icons";
import { MenuList } from "../MenuList";

export const MenuNavigationDropdown = () => {
  return (
    <DropdownMenu iconType="primary" content={<MenuList />}>
      <BlocksMenuIcon />
    </DropdownMenu>
  );
};
